import logo from '../assets/images/MAN Logo.svg'
import logout from '../assets/images/exit.svg'
import goldenLion from '../assets/images/Golden Lion.png'
import {
  ManText,
  defineCustomElements,
} from "@craft-design-system/core-components-react";

import "@craft-design-system/core-components/dist/core-components/core-components.css";

defineCustomElements();

function handleHelpClick() {
  window.location.href = `mailto:d76d4c5f.m365.man@emea.teams.ms?subject=BEV Analyzer // [Add subject] &body=Please describe your problem / feedback / question here.`;
}

const Header = () => {
  return (
    <div className='headers'>
      <div className='logo-container'>
        <img className="man-logo" src={logo} alt="MAN Logo" />
        <ManText className="logo-title" variant={"display-m"} as={"span"}>
          Battery Electric Vehicle Analyzer
        </ManText>
      </div>


      <div className='nav-items'>
        <div className='username'>
          {/* <ManText variant={"heading-xs"} as={"span"}>
            Vishal Talwar
          </ManText> */}
        </div>

        <div className='logout'>
          <a href="https://www.my.man/content/news/article/693945328987d85752ff4a19" style={{ textDecoration: 'none' }} target="_blank" rel="noopener noreferrer">
            <button style={{ background: 'white', color: 'black', padding: '10px', border: '0px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img src={goldenLion} alt="Golden Lion" style={{ width: '40px', height: '40px' }} />
            </button>
          </a>

          <a
            href="https://confluence.collaboration-man.com/spaces/MTBDANDA/pages/408084569/09-11+Release+1.4.5+28+05+2026+Enhancements+bug+fixes"
            style={{ textDecoration: 'none' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button style={{ background: 'white', color: 'black', padding: '10px', border: '0px' }}>
              <ManText className="logout" variant={"heading-s"} as={"span"}>
                Release Notes
              </ManText>
            </button>
          </a>

          <button style={{ background: 'white', border: '0px' }} onClick={handleHelpClick}>
            <ManText className="logout" variant={"heading-s"} as={"span"}>
              Need help?
            </ManText>
          </button>
        </div>
      </div>
    </div>
 )
  
};

export default Header;
